export default __webpack_public_path__ + "static/media/vr-bg.7afa879d.jpg";